import Amplify, { Auth } from "aws-amplify";

export const ENV = {
  ENDPOINT: "https://health-api.medline.com",
  CURRENT_ENV: "production",
  AWS_REGION: "us-east-2",
  AWS_USER_POOL_ID: "us-east-2_aamSJ08Ht",
  AWS_USER_POOL_WEBCLIENT_ID: "1evsq45h8l7th97ap4u4o93hqn",
};

//http://localhost:5000